/**
 * Session cache of opened documents (title + body), keyed by
 * `${workspaceId}:${documentId}` — scope-qualified so a personal doc and a
 * team doc that happen to share an id (never in practice — ids are UUIDs —
 * but defensively) never collide. Lets switching back to an already-opened
 * document render its content synchronously on mount — no async "loading"
 * frame, so no blink on tab switch.
 *
 * Extracted verbatim from DocumentEditorTab.js (which remains the writer) so
 * documentAttachmentService's CLOSED-DOC rewrite can invalidate an entry:
 * after the outbox patches a pending image into the STORED body of a document
 * whose tab is closed, a stale cache entry here would resurrect the pre-swap
 * body on reopen — the service deletes the key instead, and the reopen reads
 * the rewritten body from the store.
 */
import { recordsContext } from './documentsStore';

export const docBodyCache = new Map();

export function docBodyCacheKey(documentId, scope) {
  return `${recordsContext(scope).workspaceId}:${documentId}`;
}
